import { Component, Inject, OnInit } from "@angular/core";
import { ErrorMessage } from "./models/errorMessage.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-errorMessageDialog',
    templateUrl: './errorMessageDialog.component.html'
})

export class ErrorMessageDialogComponent {

    model: ErrorMessage = {
        header: this.data.model.header || 'Serverska greška',
        width: this.data.model.width || '70wv',
        errorMessages: this.data.model.errorMessages || ['Došlo je do greške'],
        closeLabel: this.data.model.closeLabel || 'U redu'
    };

    constructor(
        public dialogRef: MatDialogRef<ErrorMessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { model: ErrorMessage }
    ) { 
        console.log('data');
        console.log(this.data);
        console.log(this.model);
    }
  
    close(): void {
        this.dialogRef.close(false);
    }
}
